import withIcon from './NewIcon';
// @ts-ignore
import IconArrowUp from './icon/s/arrow-up.s.svg';

export default withIcon(IconArrowUp);
